import axios from '@/libs/api.request'

export const getRoominfolist = (page, limit, key, value) => {
  return axios.request({
    url: '/v1/roominfo/roominfo/',
    method: 'get',
    params: {
      key,
      value,
      page,
      limit
    }
  })
}

export const operationRoominfo = (data, meth) => {
  return axios.request({
    url: '/v1/roominfo/roominfo/',
    method: meth,
    data
  })
}

export const operationBedinfo = (data, meth) => {
  return axios.request({
    url: '/v1/roominfo/bedinfo/',
    method: meth,
    data
  })
}
